let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jsZ2h")).then(() => parcelRequire('i930f'));